module.exports = __webpack_public_path__ + "61ce060f5e43f58476d8d22a94f0a523.svg";


//////////////////
// WEBPACK FOOTER
// ./demo/img/Linkedin_20x20.svg
// module id = 287
// module chunks = 0